module.exports = __webpack_public_path__ + "static/media/eliteSilver.d7d70f86.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/eliteSilver.svg
// module id = 6620
// module chunks = 0